import React, { useEffect, useRef } from "react";
import { useInViewport } from "react-in-viewport";

import "./ab-history-menu.scss";

const HistoryMenu = ({ links, white }) => {
  // const [selected, setSelected] = useState('false');
  const myRef = useRef();
  const { inViewport, enterCount, leaveCount } = useInViewport(
    myRef,
    { threshold: 0.5 },
    {
      onEnterViewport: () => {
        // console.log("entered viewport");
      },
    },
    { disconnectOnLeave: false }
  );
  const handleScroll = () => {
    const element = document.getElementById(`menu-#tierras`);
    const menu = document.getElementById("history-menu");

    if (element) {
      if (inViewport) {
        if (!element?.classList?.contains("selected")) {
          const children = menu?.querySelectorAll("li");
          children.forEach(function(e) {
            if (e.id !== element.id) {
              e?.classList.remove("selected");
              e?.classList.add("not-selected");
            }
          });
          element?.classList.add("selected");
          element?.classList.remove("not-selected");
          document.getElementById("history-menu").scrollLeft =
            element?.offsetLeft - 10;
        }
      } else {
        if (!element?.classList?.contains("not-selected")) {
          element?.classList.remove("selected");
          element?.classList.add("not-selected");
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [inViewport]);

  // console.log('HistoryMenu', links);
  return (
    <>
      <a className="reference-tierras" id={"tierras"} />

      <div
        className={`ab-historia-menu${white ? " white" : ""}`}
        id={"ab-historia-menu"}
      >
        <nav>
          <ul id="history-menu">
            {links?.map((itm) => {
              return (
                <li
                  // className={selected == itm?.link?.url ? 'selected' : 'not-selected'}
                  id={`menu-${itm?.link?.url}`}
                  key={`menu-${itm?.link?.url}`}
                >
                  <a
                    href={itm?.link?.url}
                    // onClick={() => setSelected(itm?.link?.url)}
                  >
                    {itm?.link?.title}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
      <div id="tierras" ref={myRef} />
    </>
  );
};

export default HistoryMenu;
